/* eslint-disable @typescript-eslint/no-explicit-any */
import { AccountInfo, EventType, PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './config'

export const msalInstance = new PublicClientApplication(msalConfig)

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getActiveAccount())
}

msalInstance.addEventCallback(async (event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload) {
    const account = event.payload as AccountInfo
    msalInstance.setActiveAccount(account)
  }
  if (event.eventType === EventType.LOGIN_FAILURE && event) {
    console.log(event.error?.cause, event.error?.message)
    localStorage.removeItem('loginTime')
    if (event?.error?.message.includes('user_cancelled')) {
      msalInstance.getActiveAccount() && msalInstance.setActiveAccount(null)
      msalInstance.clearCache()
    }
  }
})

export default msalInstance
